export class HttpResponseHelper {
    static isJsonResponse (response) {
        const contentType = response.headers['content-type'];
        return contentType && contentType.includes('application/json');
    }

    static async blobResponseToJson (blobResponse) {
        const text = await blobResponse.data.text();
        return JSON.parse(text);
    }
}
